import React from 'react';
import { Text, TextMessage } from 'components/tt-forms/common';
import { ContainerFileDinhKem } from 'components/upload';

class TrinhLanhDaoTTXMView extends React.Component {

  render() {
    return (
      <div className="items-form mb5">
        <div className="row pl10 pr10 mb10">
          <Text
            className="col-input"
            label="Ban lãnh đạo:"
            value={this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo ?
              this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : ''} />
        </div>
        <div className="row pl10 pr10">
          <TextMessage
            className="col-input"
            value={this.props.thongTinXuLyGiaiQuyet.yKienGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.yKienGiaiQuyet : ''}
            label='Ý kiến xử lý:' />
        </div>
        <div className="container-filedinhkem">
          <ContainerFileDinhKem label="Danh sách văn bản xử lý" disableAttachFile={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} />
        </div>
      </div>
    );
  }
}

export default TrinhLanhDaoTTXMView;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien-nhap-lieu/TrinhLanhDaoTTXMView.jsx